<template>
  <b-overlay :show="show" rounded="md">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>
      <b-container
        class="confirmsection"
        style="
          max-width: 100% !important;
          padding-top: px;
          padding-bottom: 75px;
        "
      >
        <b-row align-h="center" style="width: 100%">
          <b-col cols="12" class="pl-0 pr-0" style="max-width: 1200px">
            <b-row style="margin-top: 90px">
              <b-col
                md="12"
                class="align-center-small"
                style="color: #111111; font-size: 34px; padding-bottom: 0px"
                >Thank you for your purchase!</b-col
              >
            </b-row>
            <b-row class="pt-4">
              <b-col style="font-size: 16px" class="align-center-small"
                >Please check your email for order confirmation. Visit us
                again!</b-col
              >
            </b-row>

            <b-row class="pt-2">
              <b-col style="font-size: 16px" class="align-center-small"
                >Your order number is: {{ orderid }}</b-col
              >
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col style="font-size: 20px">Order Summary</b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col class="pl-0 pr-0">
                <b-row
                  v-for="(item, index) in items"
                  :key="index"
                  align-v="center"
                >
                  <b-col cols="4" class="pl-0" align-self="center">
                    <b-img
                      fluid
                      :src="getImage(item.sku)"
                      style="max-width: 120px"
                    ></b-img>
                  </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px"
                  >
                    {{ item.name }}
                  </b-col>
                  <b-col align-self="center" class="">
                    <b-row>
                      <b-col
                        class="pl-0 pr-0 reduced-font"
                        style="font-size: 20px; text-align: right"
                      >
                        ${{ item.price }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="pl-0 pr-0" style="text-align: right">
                        <b>Qty: {{ item.quantity }}</b>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row class="pt-3">
                  <b-col cols="4" class="pl-0" align-self="center"> </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px"
                  >
                    Subtotal
                  </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px; text-align: right"
                  >
                    ${{ subtotal }}
                  </b-col>
                </b-row>

                <b-row class="pt-3">
                  <b-col cols="4" class="pl-0 reduced-font" align-self="center">
                  </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px"
                  >
                    Shipping & Handling
                  </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px; text-align: right"
                  >
                    ${{ shipping }}
                  </b-col>
                </b-row>

                <b-row class="pt-3">
                  <b-col cols="4" class="pl-0" align-self="center"> </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px"
                  >
                    Tax
                  </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px; text-align: right"
                  >
                    ${{ tax }}
                  </b-col>
                </b-row>

                <b-row class="pt-3">
                  <b-col cols="4" class="pl-0" align-self="center"> </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px"
                  >
                    Discount
                  </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px; text-align: right"
                  >
                    ${{ shipping_discount }}
                  </b-col>
                </b-row>

                <b-row class="pt-3">
                  <b-col cols="4" class="pl-0" align-self="center"> </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px"
                  >
                    Total
                  </b-col>
                  <b-col
                    cols="4"
                    class="reduced-font"
                    align-self="center"
                    style="font-size: 20px; text-align: right"
                  >
                    ${{ total }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>

            <b-row class="pt-1">
              <b-col style="font-size: 20px" v-if="getKioskID()==null">Shipping Address</b-col>
              <b-col style="font-size: 20px" v-else>Billing Address</b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col>
                <p style="font-size: 16px">{{ shippingname.toUpperCase() }}</p>
                <p style="font-size: 16px">{{ address1.toUpperCase() }}</p>
                <p style="font-size: 16px" v-if="address2">
                  {{ address2.toUpperCase() }}
                </p>
                <p style="font-size: 16px">
                  {{ area2.toUpperCase() }}, {{ area1.toUpperCase() }},
                  {{ country }}, {{ zipcode.toUpperCase() }}
                </p>
                <p style="font-size: 15px; margin-bottom: 0px">
                  {{ email.toUpperCase() }}
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col style="font-size: 20px">Payment Method</b-col>
            </b-row>
            <b-row class="pt-1 pb-3">
              <b-col cols="12" class="pt-2">
                <span>
                  <b-img
                    :src="getBrandImg()"
                    class="card-icon"
                    style="padding-right: 5px"
                  ></b-img>
                  <b style="padding-right: 15px">{{ getLast4() }}</b>
                  <b>{{ getExp() }}</b>
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col style="font-size: 20px">Delivery</b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col style="font-size: 16px" v-if="getKioskID()==null">
                On or before: {{ getDelivery() }}
              </b-col>
              <b-col style="font-size: 16px" v-else>
                Kiosk Self-Pickup
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pl-0 pr-0">
                <hr style="width: 100%; border: 0.5px solid #c6e3f7" />
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col style="font-size: 16px">
                If you have any questions during your ordering process, please
                <a href="/#/contact"> contact us</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import storage from "../storage";
export default {
  name: "Confirm",
  components: {
    NavHeader,
    NavFooter,
  },
  data() {
    return {
      selectedsku: [],
      orderid: "",
      name: "",
      items: [],
      breakdown: [],
      subtotal: 0,
      shipping: 0,
      shipping_discount: 0,
      tax: 0,
      total: 0,
      email: "",
      shippingname: "",
      address1: "",
      address2: "",
      area1: "",
      area2: "",
      country: "",
      zipcode: "",
      show: false,
    };
  },
  methods: {
    getKioskID(){
      return storage.getKiosk();
    },
    getDelivery() {
      var d = new Date();

      var x = 6;
      if(this.country!='US'){
        x = 14;
      }
      d.setDate(d.getDate() + x);
      return d.toLocaleDateString();
    },
    getBrandImg() {
      return "img/Paypal-Logo.png";
    },
    getLast4() {
      return "";
    },
    getExp() {
      return "";
    },
    getImage(skuid) {
      for (var i = 0; i < this.selectedsku.length; i++) {
        var sku = this.selectedsku[i].sku;
        if (sku.id == skuid) {
          return sku.metadata.image0;
        }
      }
    },
  },
  mounted() {
    var cart = storage.getCart();
    this.selectedsku = cart.selectedsku;
    var encodedstr = this.$route.query.c;
    var detail = decodeURIComponent(encodedstr);
    detail = JSON.parse(detail);
    console.log(detail)
    this.items = detail.transactions[0].item_list.items;
    this.orderid = detail.id
    this.name = detail.payer.payer_info.first_name + " " + detail.payer.payer_info.last_name;
    this.email = detail.payer.payer_info.email;
    this.total = detail.transactions[0].amount.total
    this.subtotal = detail.transactions[0].amount.details.subtotal
    this.shipping = detail.transactions[0].amount.details.shipping
    this.tax = detail.transactions[0].amount.details.tax
    this.shipping_discount = detail.transactions[0].amount.details.shipping_discount
    this.shippingname = detail.payer.payer_info.shipping_address.recipient_name
    this.address1 = detail.payer.payer_info.shipping_address.line1

    this.address2 = detail.payer.payer_info.shipping_address.line2
    this.area1 = detail.payer.payer_info.shipping_address.city
    this.area2 = detail.payer.payer_info.shipping_address.state
    this.country = detail.payer.payer_info.shipping_address.country_code;
    this.zipcode = detail.payer.payer_info.shipping_address.postal_code

    storage.clearCart();
    //this.$refs.header.updateCart();

  },
};
</script>

<style lang="scss">
.card-icon {
  height: 20px;
}

.confirmsection {
  min-height: calc(100vh - 169px) !important;
}

@media (max-width: 768px) {
  .reduced-font {
    font-size: 16px !important;
  }
}
</style>